import React from 'react';
import { jwtDecode } from 'jwt-decode';

import HeadlinePanel from '../Components/HeadlinePanel';

import AMMembershipFees from '../Components/TablesForMembershipFeesPage/AMMembershipFees';
import WorkerMembershipFees from '../Components/TablesForMembershipFeesPage/WorkerMembershipFees';

import Loading from '../Components/Loading';

export default function MembershipFees() {
  const [userId, setUserId] = React.useState('');
  const [userRole, setUserRole] = React.useState('');

  React.useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      const decodedToken = jwtDecode(token);
      setUserId(decodedToken.id);
      setUserRole(decodedToken.role);
    }
  }, []);


  if (!userId || !userRole) {
    return <Loading />;
  }

  return (
    <>
      <div className='mainContainer'>
        <HeadlinePanel label= 'Членские взносы' type='' />
        <div className='containerInner'>
          {userRole === 'Арбитражный управляющий' ? (
            <AMMembershipFees userId={userId} userRole={userRole} isFromAccount={false} />
          ) : (
            <WorkerMembershipFees />
          )}
        </div>
      </div>
    </>
  );
};
